import { Box, Button } from '@mui/material'
import React from 'react'
import AssignClustertoCoordinator from '../commonfile/AssignClustertoCoordinator'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import AddUserForm from '../admin/AddUserForm'
import CustomDivider from '../../shared/utils/CustomDivider'
import CoordinatorListTable from '../commonfile/CoordinatorListTable'

const ZoneManagerCoordinatorList = () => {
    const { open, handleClickOpen, handleClose } = useDialog();
    return (
        <Box>
            <NormalContainerWithHeader headerText={"Assign Cluster to Coordinator"} RightContent={<Button variant='contained' onClick={handleClickOpen}>Add Coordinator</Button>}>
                <AssignClustertoCoordinator />
            </NormalContainerWithHeader>
            <MainDialogBox open={open} handleClose={handleClose} width={"60%"}>
                <AddUserForm
                    onClose={handleClose}
                    RoleOption={[{
                        id: 1,
                        label: 'coordinator',
                        value: "coordinator"
                    },]}
                    role="user"
                />
            </MainDialogBox>
            <CustomDivider/>
            <CoordinatorListTable/>
        </Box>
    )
}

export default ZoneManagerCoordinatorList